module.exports = __webpack_public_path__ + "static/img/sp11.2abd4a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sp11.jpg
// module id = Nr5S
// module chunks = 0